<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.title"
            label="Tytuł"
            placeholder=" "
            :counter="50"
            :rules="rules.textFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea
            class="mt-0 pt-0"
            v-model="debouncedFilters.body"
            label="Treść"
            placeholder=" "
            rows="2"
            :counter="500"
            :rules="rules.textFilter"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.targetUrl"
            label="URL"
            placeholder=" "
            :counter="254"
            :rules="rules.targetUrlFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <label
            class="v-label v-label--active theme--light"
            style="height: 20px; line-height: 20px; font-size: 13px;"
        >
          Opóźnienie w minutach
        </label>
        <v-range-slider
            v-model="debouncedFilters.delayInMinutes"
            :min="0"
            :max="2880"
            :hint="delayInHours(debouncedFilters.delayInMinutes)"
            persistent-hint
            class="align-center"
        >
          <template v-slot:prepend>
            <v-text-field
                :value="debouncedFilters.delayInMinutes[0]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.delayInMinutes, 0, $event)"
            />
          </template>
          <template v-slot:append>
            <v-text-field
                :value="debouncedFilters.delayInMinutes[1]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.delayInMinutes, 1, $event)"
            />
          </template>
        </v-range-slider>
      </v-col>
      <v-col cols="12">
        <label
            class="v-label v-label--active theme--light"
            style="height: 20px; line-height: 20px; font-size: 13px;"
        >
          Przedział godzinowy
        </label>
        <v-range-slider
            v-model="debouncedFilters.hours"
            :min="0"
            :max="23"
            hide-details
            class="align-center"
        >
          <template v-slot:prepend>
            <v-text-field
                :value="debouncedFilters.hours[0]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.hours, 0, $event)"
            />
          </template>
          <template v-slot:append>
            <v-text-field
                :value="debouncedFilters.hours[1]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.hours, 1, $event)"
            />
          </template>
        </v-range-slider>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="createdAt"
                label="Okres zakolejkowania"
                prepend-icon="mdi-calendar-blank"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                hide-details
            />
          </template>
          <v-date-picker
              v-model="createdAtRange"
              range
              show-adjacent-months
              :first-day-of-week="1"
              :max="maxDate"
              @change="onCreatedAtChanged"
          />
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.forMobile"
            label="Mobilne"
            hide-details
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko powiadomienia, które zostały skierowane przynajmniej na urządzenia mobilne.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.forWeb"
            label="Przeglądarka"
            hide-details
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko powiadomienia, które zostały skierowane do przeglądarek.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.sent"
            label="Tylko częściowo wysłane"
            hide-details
            @click="onSentSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko powiadomienia, które zostały wysłane na przynajmniej jedno urządzenie.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.notSent"
            label="Tylko częściowo niewysłane"
            hide-details
            @click="onNotSentSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko powiadomienia, które NIE zostały wysłane na przynajmniej jedno urządzenie.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.cancelled"
            label="Tylko anulowane"
            hide-details
            @click="onCancelledSwitched"
        ></v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.notCancelled"
            label="Tylko nieanulowane"
            hide-details
            @click="onNotCancelledSwitched"
        ></v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.withoutBatch"
            label="Bez paczki"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko powiadomienia automatyczne, czyli takie, które nie zostały zakolejkowane z poziomu Panelu Admina.
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.targetUser"
            label="ID odbiorcy"
            placeholder=" "
            :counter="10"
            :rules="rules.userFilter"
            hint="Tylko cyfry, bez #."
            persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-7">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.creator"
            label="ID kolejkującego"
            placeholder=" "
            :counter="10"
            :rules="rules.userFilter"
            hint="Tylko cyfry, bez #."
            persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-7">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.batchId"
            label="ID paczki"
            placeholder=" "
            :counter="26"
            :rules="rules.textFilter"
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";
import formatters from "@/mixins/formatters";

export default {
  mixins: [
    formatters,
  ],
  data() {
    return {
      menu1: false,
      createdAtRange: [null, null],
      filterDebouncing: null,
      standardFilters: {
        createdAtFrom: null,
        createdAtTo: null,
        forMobile: false,
        forWeb: false,
        sent: false,
        notSent: false,
        cancelled: false,
        notCancelled: false,
        withoutBatch: false,
      },
      debouncedFilters: {
        title: '',
        body: '',
        targetUrl: '',
        delayInMinutes: [0, 2880],
        hours: [0, 23],
        targetUser: '',
        creator: '',
        batchId: '',
      },
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
        targetUrlFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
        userFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 1 || 'Wpisz co najmniej jeden znak.'
          },
        ],
      },
    };
  },
  created() {
    this.filterDebouncing = debounce(function () {
      this.filter();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filter();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterDebouncing();
      },
      deep: true
    },
  },
  computed: {
    createdAt: {
      get() {
        return this.createdAtRange.filter((date) => {
          return null !== date;
        }).join(' - ');
      },
      set(dateRange) { // Called when user clicks "X" button to clear the text-field.
        if (null === dateRange) {
          dateRange = [null, null];
        }

        this.createdAtRange = dateRange;
        this.onCreatedAtChanged(dateRange); // Trigger the callback manually.
      }
    },
    maxDate() {
      return this.isoDateTime(new Date());
    },
  },
  methods: {
    delayInHours(range) {
      const from = this.formatMinutes(range[0] || 0)
      const to = this.formatMinutes(range[1] || 23)

      return `${from} - ${to}`
    },
    onSentSwitched() {
      if (this.standardFilters.sent && this.standardFilters.notSent) {
        this.standardFilters.notSent = false
      }
    },
    onNotSentSwitched() {
      if (this.standardFilters.notSent && this.standardFilters.sent) {
        this.standardFilters.sent = false
      }
    },
    onCancelledSwitched() {
      if (this.standardFilters.cancelled && this.standardFilters.notCancelled) {
        this.standardFilters.notCancelled = false
      }
    },
    onNotCancelledSwitched() {
      if (this.standardFilters.notCancelled && this.standardFilters.cancelled) {
        this.standardFilters.cancelled = false
      }
    },
    onCreatedAtChanged(dateRange) {
      this.menu1 = false;
      this.standardFilters.createdAtFrom = dateRange[0];
      this.standardFilters.createdAtTo = dateRange[1];
    },
    filter() {
      this.$root.$emit('loadNotifications', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
  }
}
</script>